import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import api from '../../api';
import helpers from '../../helpers'
import CustomDataTable from '../../components/custom-data-table/custom-data-table';
import MoviePosterImage from '../../components/movie-poster-image/movie-poster-image.component';



let _movieHelper = helpers.movie;

let comingSoonCutoffDays = 3;   // NOTE: keep in sync with main app value in services.js
let recentCutoffDate = moment().subtract(comingSoonCutoffDays, 'days');

let _expectedDateFormatter = (date) => {
  let dateStr = _movieHelper.formatLongDateValue(date);
  let isRecent = date && recentCutoffDate.isSameOrBefore(date);
  let classes = 'expected-date' + (isRecent? ' recent-date': '');

  return (
    <div className={classes}>
      { dateStr }
    </div>
  );
};

let _movieTitleFormatter = (value, row, rowIdx) => {
  let movie = _.get(row, 'movie') || {};
  return (
    <div className="movie-title-preview d-flex flex-row">
      <MoviePosterImage movie={movie} resolutionSize="50x50" />
      <div className="movie-title mt-1 ml-3 flex-fill">{movie.title}</div>
    </div>
  );
};

let _columnHeaders = [
  {
    label: 'Movie',
    field: 'movie.title',
    formatter: _movieTitleFormatter,
    sort: 'asc',
    width: 150
  },
  {
    label: 'Expected Date',
    field: 'dateMomentValue',
    formatter: _expectedDateFormatter,
    sort: 'desc',
    width: 50
  },
  {
    label: 'Override Label',
    field: 'date_label',
    sort: 'desc',
    width: 50
  },
  {
    label: 'Sort Order',
    field: 'sortIndexIntValue',
    // formatter: _sortIndexFormatter,
    sort: 'asc',
    width: 50
  },
  {
    label: 'Comments',
    field: 'comments',
    sort: 'asc',
    width: 150
  },
];

let _pageNumOffset = 1;

let _paginationOpts = {
  l: 20,
};

class ComingSoonList extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    recentOnly: PropTypes.bool,
  };

  static defaultProps = {
    recentOnly: true,
  };

  constructor(props) {
    super(props);

    let pageData = CustomDataTable.EmptyPageData;
    pageData.maxItemsPerPage = _paginationOpts.l;
    pageData.activePageIdx = 0;
    pageData.firstPageIdx = 0;
    pageData.lastPageIdx = 0;

    let sortData = CustomDataTable.EmptySortData;

    this.state = {
      items: null,
      pageData: pageData,
      sortData: sortData,
    };

    this.handleAddClicked = this.handleAddClicked.bind(this);
    this.handleSortChanged = this.handleSortChanged.bind(this);
    this.handlePageChanged = this.handlePageChanged.bind(this);
    this.handleRowClicked = this.handleRowClicked.bind(this);
    this.invalidateData = this.invalidateData.bind(this);

    this.invalidateData();
  }

  handleAddClicked(e) {
    this.props.history.push('/coming-soon/add');
  }

  handleSortChanged(e) {
    // console.log('handleSortChanged: ' + JSON.stringify(e));

    if (!_.isEqual(this.state.sortData, e)) {
      let sortData = _.cloneDeep(this.state.sortData);

      // TODO: joe- handle this case

      this.setState({ sortData }, this.invalidateData);
    }
  }

  handlePageChanged(e) {
    // console.log('handlePageChanged: ' + JSON.stringify(e));

    if (this.state.pageData.activePageIdx !== e.activePageIdx) {
      let pageData = _.cloneDeep(this.state.pageData);
      pageData.activePageIdx = e.activePageIdx;

      this.setState({ pageData }, this.invalidateData);
    }
  }

  handleRowClicked(dataItem) {
    // navigate to edit page
    let id = _.get(dataItem, 'id', null);
    this.props.history.push('/coming-soon/edit/' + id);
  }

  invalidateData() {
    let q = {};
    q = _.extend(q, _paginationOpts);

    q.p = (this.state.pageData.activePageIdx || 0) + _pageNumOffset;

    // sort field and sort order
    if (this.state.tableSort) {
      q.sf = _.replace(this.state.tableSort.column, /_?Formatted$/i, '');
      q.so = this.state.tableSort.direction || 'asc';
    } else {
      q.sf = 'date,sort_index';
      q.so = 'desc,asc';
    }

    if (this.props.recentOnly) {
      let recentCutoffDate = moment().subtract(4, 'weeks');
      q.date_start = recentCutoffDate.format('YYYY-MM-DD HH:mm:ss');
    }

    if (this.prevQuery && _.isEqual(this.prevQuery, q)) {
      return false;
    }
    this.prevQuery = q;


    return api.comingSoon.find(q).then(async res => {
      let items = _.get(res, 'data') || null;
      items = _.chain(items)
        .map(item => {
          if (!item) { return null; }
          return item;
        })
        .compact()
        .value();

      let movieIds = _.chain(items)
        .map('movie_id')
        .uniq()
        .compact()
        .value();

      if (!_.isEmpty(movieIds)) {
        let qMovies = { l: 10000, f: 'id:' + _.join(movieIds, '^') };
        let resMovies = await api.movies.find(qMovies);
        let movies = _.get(resMovies, 'data') || null;
        let movieIdMap = _.keyBy(movies, 'id') || {};
        items = _.map(items, item => {
          item.movie = movieIdMap[item.movie_id] || null;
          // item.movie_title = _.get(item.movie, 'title', null);
          return item;
        });

      }


      let pageData = _.cloneDeep(this.state.pageData);

      let meta = _.get(res, 'meta') || null;
      if (meta) {
        pageData.activePageIdx = meta.pageNumber - _pageNumOffset;
        pageData.numItems = meta.totalRecords;
        pageData.numTotalPages = meta.totalPages;
        pageData.numTotalItems = meta.totalRecords;
        pageData.lastPageIdx = pageData.numTotalPages - 1;
     }

      this.setState({ items, pageData });
      return true;
    });
  }

  render() {

    let tableData = this.state.items;
    let sortData = this.state.sortData;
    let pageData = this.state.pageData;

    return (
      <div className="coming-soon-list" >
        <CustomDataTable
          striped={true}
          showAddButton={true}
          showSearch={false}
          showSort={false}
          showPaging={true}

          onAddClicked={this.handleAddClicked}
          onSortChanged={this.handleSortChanged}
          onPageChanged={this.handlePageChanged}
          onRowClicked={this.handleRowClicked}

          headers={_columnHeaders}
          data={tableData}

          title="Manage Coming Soon Movies"
          searchLabel={''}
          sortData={sortData}
          pageData={pageData}
        />
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ComingSoonList));

